export default "__VITE_ASSET__c0c49a46__"